import { z } from 'zod';
/**
 * The Tracker: the external system the Studio reads Apps and their Custom Store
 * Listings from.
 *
 * It is reached with an address and a read-only token, in that order. Both are kept
 * where provider keys are kept - saved on the Providers page under these names, with
 * the deployment environment as the fallback - and read at the moment of use.
 */
export const TRACKER_KEY_NAMES = ['TRACKER_API_URL', 'TRACKER_API_TOKEN'];
/** One Tracker Import is one `POST` here, with no body. */
export const TRACKER_IMPORTS_PATH = '/api/v1/tracker-imports';
/**
 * What one Tracker Import did, returned to the operator who pressed the button.
 *
 * `added` lists what this import created; `existing` counts what the Tracker named and
 * the Studio already had, which is left exactly as it was. Nothing is ever removed.
 */
export const TrackerImportReportSchema = z.object({
    apps: z.object({
        added: z.array(z.object({ id: z.string(), packageName: z.string(), displayName: z.string() })),
        existing: z.number().int().nonnegative(),
    }),
    storeListings: z.object({
        added: z.array(z.object({ id: z.string(), appId: z.string(), appDisplayName: z.string(), listingParam: z.string() })),
        existing: z.number().int().nonnegative(),
    }),
    /** `subject` is what the Tracker called it; `reason` is a sentence for the operator. */
    skipped: z.array(z.object({ subject: z.string(), reason: z.string() })),
});
//# sourceMappingURL=tracker.js.map